import React from 'react';

import { Flex, useTheme } from '@chakra-ui/react';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

export const TAG_SIZE = {
  regular: 'regular',
  large: 'large',
};

export const TagColored = ({
  children,
  color,
  size = TAG_SIZE.regular,
  StartIcon = null,
  startIconColor = null,
  isRounded = false,
  isCharCountTruncate = false,
  truncateCharCount = 0,
  EndIcon = null,
  EndIconColor = null,
  ...props
}) => {
  const theme = useTheme();

  const TAG_COLORS = {
    yellow: {
      textColor: theme.colors.functional.B96400,
      bgColor: theme.colors.feedback.FFF6E4,
    },
    red: {
      textColor: theme.colors.functional.C62C02,
      bgColor: theme.colors.feedback.FFF1E4,
    },
    black: {
      textColor: theme.colors.text.g1,
      bgColor: theme.colors.neutral.F5F7F9,
    },
    green: {
      textColor: theme.colors.functional['44812F'],
      bgColor: theme.colors.feedback.EFFFEA,
    },
    darkGreen: {
      textColor: theme.colors.functional['1A5724'],
      bgColor: theme.colors.feedback.DBF2D3,
    },
    blue: {
      textColor: theme.colors.functional['1565BC'],
      bgColor: theme.colors.feedback.E6F1FD,
    },
    grey: {
      textColor: theme.colors.functional['666666'],
      bgColor: theme.colors.feedback.F2F2F2,
    },
    darkGrey: {
      textColor: theme.colors.functional['333333'],
      bgColor: '#EBEFF3',
    },
    brandRed: {
      textColor: theme.colors.surface.white,
      bgColor: theme.colors.brand.red,
    },
    greenSecondary: {
      textColor: '#2D8C32',
      bgColor: '#2D8C3229',
    },
    greySecondary: {
      textColor: '#666666',
      bgColor: '#E7E7E7',
    },
    pending: {
      textColor: '#C62C02',
      bgColor: '#C62C0229',
    },
    submitted: {
      textColor: '#E29600',
      bgColor: '#E2960029',
    },
    acknowledged: {
      textColor: '#235826',
      bgColor: '#2D8C3229',
    },
    darkYellow: {
      textColor: '#8C6A00',
      bgColor: '#FFF6D3',
    },
  };

  const tagColors = TAG_COLORS[color] ?? TAG_COLORS.black;

  const { textColor, bgColor } = tagColors;

  return (
    <Flex
      alignItems="center"
      py={size === TAG_SIZE.regular ? '2px' : '4px'}
      pl={StartIcon ? 1 : 2}
      pr={2}
      bg={bgColor}
      borderRadius={isRounded ? '32px' : '4px'}
      w="max-content"
      {...props}
    >
      {StartIcon && (
        <StartIcon
          boxSize="16px"
          color={startIconColor ? (TAG_COLORS?.[startIconColor].textColor ?? startIconColor) : textColor}
        />
      )}
      <TextBodyMedium
        bold
        color={textColor}
        ml={StartIcon ? 1 : 0}
        mr={EndIcon ? 1 : 0}
        isCharCountTruncate={isCharCountTruncate}
        truncateCharCount={truncateCharCount}
      >
        {children}
      </TextBodyMedium>
      {EndIcon && (
        <EndIcon
          color={EndIconColor ? (TAG_COLORS?.[EndIconColor].textColor ?? EndIconColor) : textColor}
          boxSize="16px"
        />
      )}
    </Flex>
  );
};
